var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoPlayer',{ref:"hlsPlayer",attrs:{"options":_vm.options},on:{"player-state-changed":_vm.playerStateChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }